var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSponsorshipFunds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D3CFD0",
    fillRule: "nonzero",
    d: "M0 9H50V22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7h50a15.879 15.879 0 0 1-4.75 11.316A16.337 16.337 0 0 1 33.772 23H16.245a16.338 16.338 0 0 1-11.489-4.678A15.879 15.879 0 0 1 0 7z",
    stroke: "#4C4748",
    strokeWidth: 0.7,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4748",
    strokeWidth: 0.7,
    d: "M0 7H50V43H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4748",
    strokeWidth: 0.7,
    d: "M14 0H36V7H14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C4748",
    strokeWidth: 0.7,
    fill: "#D3CFD0",
    fillRule: "nonzero",
    d: "M14 0H36V3H14z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#EA6925",
    strokeWidth: 0.7,
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 25.5,
    cy: 22.5,
    r: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorshipFunds);
export default __webpack_public_path__ + "static/media/sponsorship-funds.253bceee58c3d716b2abbc8759210635.svg";
export { ForwardRef as ReactComponent };